import axios from "axios";

export default function bootstrap() {
  return new Promise((resolve, reject) =>
    axios
      .get(`/account/system-admin/api/v1/bootstrap`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
